import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../Services/api";

const PentagovContext = createContext();

const PentagovProvider = ({ children }) => {
    const [IDClienteAberto, setIDClienteAberto] = useState(null);
    const [objClienteAberto, setObjClienteAberto] = useState(null);
    const [IDProcessoAberto, setIDProcessoAberto] = useState(null);
    const [objProcessoAberto, setObjProcessoAberto] = useState(null);
    const [IDPastaAberta, setIDPastaAberta] = useState(null);
    const [objPastaAberta, setObjPastaAberta] = useState(null);
    const [bucketAberto, setBucketAberto] = useState(null);

    const resetaVariaveis = () => {
        setIDClienteAberto(null);
        setObjClienteAberto(null);
        setIDProcessoAberto(null);
        setObjProcessoAberto(null);
        setIDPastaAberta(null);
        setObjPastaAberta(null);
        setBucketAberto(null);
    };

    useEffect(() => {
        const buscaCliente = async (IDCliente) => {
            if (!IDCliente) return null;
            try {
                const res = await api.get(`/cliente/${IDCliente}`);
                setObjClienteAberto(res.data.Cliente);
            } catch (err) {
                console.error("Erro ao buscar cliente:", err);
                setObjClienteAberto(null);
            }
        };

        if (IDClienteAberto) buscaCliente(IDClienteAberto);
    }, [IDClienteAberto]);

    useEffect(() => {
        const buscaProcesso = async (IDProcesso) => {
            if (!IDProcesso) return null;
            try {
                const res = await api.get(`/processo/${IDProcesso}`);
                setObjProcessoAberto(res.data.Processo);
            } catch (err) {
                console.error("Erro ao buscar processo:", err);
                setObjProcessoAberto(null);
            }
        };

        if (IDProcessoAberto) buscaProcesso(IDProcessoAberto);
    }, [IDProcessoAberto]);

    useEffect(() => {
        const buscaPasta = async (IDPasta) => {
            if (!IDPasta) return null;
            try {
                const res = await api.get(`/diretorio/${IDPasta}`);
                setObjPastaAberta(res.data.Diretorio);
            } catch (err) {
                console.error("Erro ao buscar pasta:", err);
                setObjPastaAberta(null);
            }
        };
        const buscaBucket = async (IDPasta) => {
            if (!IDPasta) return null;
            try {
                const res = await api.get(`/processo/diretorio/${IDPasta}`);
                setBucketAberto(res.data.nomeBucketAws);
            } catch (err) {
                console.error("Erro ao buscar processo por diretorio:", err);
                setBucketAberto(null);
            }
        };

        if (IDPastaAberta && IDPastaAberta > 0) {
            buscaPasta(IDPastaAberta);
            buscaBucket(IDPastaAberta);
        }
    }, [IDPastaAberta]);

    return (
        <PentagovContext.Provider
            value={{
                IDClienteAberto,
                setIDClienteAberto,
                objClienteAberto,
                IDProcessoAberto,
                setIDProcessoAberto,
                objProcessoAberto,
                IDPastaAberta,
                setIDPastaAberta,
                objPastaAberta,
                bucketAberto,
                setBucketAberto,
                resetaVariaveis,
            }}
        >
            {children}
        </PentagovContext.Provider>
    );
};

const usePentagovContext = () => useContext(PentagovContext);

export { PentagovProvider, usePentagovContext };
